/* eslint-disable consistent-return */
import { Alert, Button, Card, Col, Layout, Row, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";

import { getSupaClient } from "../../lib/supabase";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";
import { ADD_TO_SLACK_URL, LOGIN_SLACK_URL } from "../../utils/constants";

const { Content } = Layout;
const { TabPane } = Tabs;

const SlackPermissions = () => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [sessionExists, setSessionExists] = useState(false);
  const navigate = useNavigate();
  const addToSlack = (
    <>
      <Row type="flex" justify="center" align="middle">
        <Col span={12}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              style={{ marginTop: 10 }}
              alt="download"
              src="/Download.svg"
              width="270"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="flex flex-col justify-center">
            <div>
              <h3 style={{ marginBottom: "50px" }}>
                Please give us permissions to your workspace!{" "}
              </h3>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <a href={`${ADD_TO_SLACK_URL}/auth/added/`}>
                <img
                  className="flex  justify-center"
                  alt="Add to Slack"
                  height="40"
                  width="139"
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                />
              </a>
            </div>
          </div>
        </Col>
      </Row>
      <Row type="flex" justify="center" align="middle" className="pt-10">
        <div style={{ maxWidth: "650px" }}>
          PS: We only collect public channel data and store it securely. Data
          from your workspace won&#39;t be used for any other purposes than the
          app itself. <strong>We will never sell your data.</strong> All data
          will be deleted right away if you decide to delete the account!
        </div>
      </Row>
    </>
  );

  const signInWithSlack = (
    <>
      <Row type="flex" justify="center" align="middle">
        <Col span={12}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              style={{ marginTop: 10 }}
              alt="insights dots"
              src="/analyse.png"
              width="340"
            />
          </div>
        </Col>

        <Col span={12}>
          <h3 style={{ marginBottom: "50px" }}>
            Please authenticate with your Slack workspace.
          </h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a href={`${LOGIN_SLACK_URL}`}>
              <img
                alt="Sign in with Slack"
                height="40"
                width="172"
                src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
                srcSet="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
              />
            </a>
          </div>
        </Col>
      </Row>
      <Row type="flex" justify="center" align="middle" className="pt-10">
        <div style={{ maxWidth: "650px" }}>
          <b>
            Note: Only admins are able to schedule mass DMs. If you want to do
            that through Dots, please ask your admin to make you a Slack admin
          </b>
        </div>
      </Row>
      <Row type="flex" justify="center" align="middle" className="pt-10">
        <div style={{ maxWidth: "650px" }}>
          PS: Upon successful sign in with Slack, please message
          hello@dots.community to approve your account for access to Dots.
        </div>
      </Row>
    </>
  );

  const TeamRoleButton = ({ chosenRole, pathTo }) => (
    <div style={{ display: "flex", justifyContent: "center", padding: "18px" }}>
      <a href={pathTo}>
        <Button
          size="large"
          type="default"
          style={{
            fontWeight: "bold",
            borderWidth: "2px",
            height: "55px",
            whiteSpace: "normal",
          }}
        >
          {chosenRole}
        </Button>
      </a>
    </div>
  );

  const NoSession = () => (
    <div>
      <Content align="middle">
        <Row style={{ marginTop: "100px" }}>
          <Col span={8} offset={8}>
            <Alert
              message="No session"
              description="We couldn't find a user session. Please contact us for support at hello@dots.community!"
              type="error"
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Col span={8} offset={8}>
            <Button type="link" onClick={() => navigate(`/signin`)}>
              Back to Sign In{" "}
            </Button>
          </Col>
        </Row>
      </Content>
    </div>
  );

  const ShowPermissions = () => (
    <Row
      type="flex"
      justify="center"
      align="middle"
      style={{
        flexDirection: "column",
        minHeight: "100vh",
        padding: "0 200px",
      }}
    >
      <Card
        style={{
          textAlign: "center",
          width: "75%",
          height: "550px",
        }}
      >
        <Row
          align="middle"
          justify="center"
          style={{
            margin: "6.6rem 0 1rem 0",
            fontWeight: "500",
            fontSize: "16px",
          }}
        >
          What is your team role in Slack?
        </Row>
        <Row align="middle" justify="center">
          <TeamRoleButton
            chosenRole="Workspace Admin"
            pathTo="/onboarding/slack/admin"
          />
          <TeamRoleButton
            chosenRole="Approved Slack Member"
            pathTo="/onboarding/slack/member"
          />
        </Row>
      </Card>
      <div
        style={{
          background: "#FFFFFF",
          fontSize: 12,
          bottom: 0,
          marginTop: 10,
          textAlign: "center",
          justifyContent: "space-evenly",
          fontWeight: "500",
          position: "absolute",
          marginBottom: "1.7rem",
        }}
      >
        Use chat, <a href="https://discord.gg/WJFTPtvGGw"> discord </a> , or
        <a href="mailto:hello@dots.community"> email </a> for help!
      </div>
    </Row>
  );

  const Loading = () => (
    <div>
      <Content align="middle">
        <Row style={{ marginTop: "100px" }}>
          <Col span={8} offset={8}>
            <DotsFishLoading />
          </Col>
        </Row>
      </Content>
    </div>
  );

  const checkSession = async () => {
    const session = supabase.auth.session();
    if (session) {
      if (session.user) {
        setSessionExists(true);
        setLoading(false);
      }
    } else {
      setSessionExists(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSession();
  }, []);

  // let showComponent = <Loading />;
  if (loading) {
    return <Loading />;
  }
  if (sessionExists) {
    return <ShowPermissions />;
  }
  return <NoSession />;

  // return <div>{showComponent}</div>;
};

export default SlackPermissions;
